function createBrokerService() {
    // @ts-ignore: The generic from `BrokerTopicLister<T>` may change with each published message, so we ignore it here
    // as `topics` is meant only as a
    const topics = new Map();
    const publishToTopic = (topic, message) => {
        const listeners = topics.get(topic);
        if (!listeners || (listeners && listeners.size < 0)) {
            return;
        }
        for (const listener of listeners) {
            listener(message);
        }
    };
    const subscribeToTopic = (topic, listener) => {
        const listeners = topics.get(topic) ?? new Set();
        if (listeners.has(listener)) {
            throw Error('[Broker Service]: This listener is already listening to topic messages');
        }
        listeners.add(listener);
        topics.set(topic, listeners);
        return () => {
            const listeners = topics.get(topic) ?? new Set();
            if (listeners.has(listener)) {
                listeners.delete(listener);
                topics.set(topic, listeners);
            }
        };
    };
    return {
        publishToTopic,
        subscribeToTopic,
    };
}
const BrokerService = createBrokerService();
export { BrokerService, };
//# sourceMappingURL=broker-service.js.map